import { createSelector } from 'reselect'
import getDeliveryAvailabilityShippingSelect from 'modules/shipping/redux/selectors/get-delivery-availability'

const isFastDeliveryAvailableShippingSelect = createSelector(
  getDeliveryAvailabilityShippingSelect,
  deliveryAvailability => deliveryAvailability?.data?.isFastDeliveryAvailable
)

export default isFastDeliveryAvailableShippingSelect
